export default "__VITE_ASSET__c9L5bZWY__"